import OfficeBlockInfo from './OfficeBlockInfo';

import { IOfficeBlock } from 'source/NFR.types';

const OfficeBlock: React.FC<IOfficeBlock> = ({ info = [], title }) => (
  <div className="office-block">
    {title && <h2>{title}</h2>}
    <div className="office-block--info">
      {info?.map(infoItem => (
        <div className="office-block--info-item" key={infoItem.title}>
          <OfficeBlockInfo {...infoItem} />
        </div>
      ))}
    </div>
  </div>
);

OfficeBlock.displayName = 'OfficeBlock';

export default OfficeBlock;
